import React from 'react';
import { number, bool } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import GenericTooltip from '../GenericTooltip';
import { VisType } from '../../constants';

class MapTooltips extends React.Component {
  state = {
    selectedPoint: null,
    hoveredPoint: null,
  };

  componentWillReceiveProps({ location }) {
    // Remove all tooltip on route changes
    if (location.pathname !== this.props.location.pathname) {
      this.clear();
    }
  }

  onMouseEnter = point => {
    const { selectedPoint } = this.state;
    if (selectedPoint && point.id === selectedPoint.id) return;
    this.setState({ hoveredPoint: point });
  };

  onMouseLeave = () => this.setState({ hoveredPoint: null });

  onClickDataPoint = (point, e) => {
    const { selectedPoint } = this.state;
    e.stopPropagation();

    this.setState({
      selectedPoint:
        selectedPoint && point.id === selectedPoint.id ? null : point,
      hoveredPoint: null,
    });
  };

  clear = () => {
    this.setState({
      selectedPoint: null,
      hoveredPoint: null,
    });
  };

  renderTooltips = () => {
    const { selectedPoint, hoveredPoint } = this.state;
    const {
      location,
      censusMode,
      containerHeight,
      containerWidth,
    } = this.props;

    const commonProps = {
      visType: VisType.MAP,
      bounds: { width: containerWidth, height: containerHeight, padding: 8 },
      link:
        process.env.REACT_APP_FEATURE_CENSUS && !censusMode ? (
          <Link
            to={{
              pathname: `/map${selectedPoint ? '/' + selectedPoint.id : ''}`,
              search: location.search,
            }}
            onClick={this.onClickCensusLink}
          >
            Explore tracts
          </Link>
        ) : null,
    };

    return (
      <React.Fragment>
        {hoveredPoint || selectedPoint ? (
          <GenericTooltip
            hoverable={!!selectedPoint}
            {...selectedPoint || hoveredPoint}
            {...commonProps}
          />
        ) : null}
        {hoveredPoint && selectedPoint ? (
          <GenericTooltip {...hoveredPoint} {...commonProps} />
        ) : null}
      </React.Fragment>
    );
  };

  render() {
    const { selectedPoint, hoveredPoint } = this.state;

    return this.props.children({
      renderTooltips: this.renderTooltips,
      selectedPoint,
      hoveredPoint,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onClick: this.onClickDataPoint,
      clear: this.clear,
    });
  }
}

MapTooltips.propTypes = {
  censusMode: bool.isRequired,
  containerWidth: number.isRequired,
  containerHeight: number.isRequired,
};

export default withRouter(MapTooltips);



// WEBPACK FOOTER //
// ./src/components/MapPage/MapTooltips.jsx